<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2 px-4 py-5 color-bg-login min-h-img">
              <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
              <img src="@/assets/images/pages/register2.svg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col lg:mt-5 sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg ">
              <div class="p-8 login-tabs-container ">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Restablecer contraseña</h4>
                  <p>Rellena los siguientes datos para restablecer la contraseña de tu cuenta.</p>
                </div>

                <div class="vx-row">

                  <div class="vx-col w-full">
                    <vs-input
                      ref="password"
                      :type="type"
                      name="password"
                      label-placeholder="Password"
                      placeholder="Contraseña"
                      autocomplete="off"
                      v-model="password"
                      class="w-full mt-6" />
                    <div class="form-control-position field-icon">
                      <a @click="showPassword">
                        <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
                      </a>
                    </div>
                  </div>

                  <div class="vx-col w-full">
                    <vs-input
                      :type="type"
                      name="confirm_password"
                      autocomplete="off"
                      label-placeholder="Confirm Password"
                      placeholder="Repetir contraseña"
                      v-model="password_confirmation"
                      class="w-full mt-6" />
                    <div class="form-control-position field-icon">
                      <a @click="showPassword">
                        <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
                      </a>
                    </div>
                  </div>

                  <div class="vx-col">
                    <vs-button :disabled="isSubmitted" ref="loadableButton" id="button-with-loading" class="mt-6 vs-con-loading__container" @click="submitCreatePassword" type="relief" vslor="primary">Aceptar</vs-button>

                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import router from "../../../../router";

export default {
  name: "CreatePasswordProcess",
  data() {
    return {
      icon: 'EyeIcon',
      type: 'password',
      password: '',
      password_confirmation: '',
      token: null,
      isSubmitted: false
    }
  },
  methods: {
    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    submitCreatePassword() {
      this.$store.dispatch("alert/clear", {}, {root:true})
      if (!this.password && !this.password_confirmation) {
        this.$store.dispatch("alert/error", "Ingresa los datos solicitados");
        return;
      }
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#button-with-loading",
        scale: 0.45
      });
      this.isSubmitted = true;
      this.$store.dispatch("account/forgotPassword", {password: this.password, password_confirmation: this.password_confirmation, token: this.token})
      .then(
        () => {
          this.isSubmitted = false;
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        },
        () => {
          this.isSubmitted = false;
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        }
      )
    }
  },
  created() {
    let token = this.$route.params.token;
    if (token) {
      this.token = token;
    } else {
      router.push("/");
    }
  }
}
</script>

<style scoped>

</style>
